export default {
      id: "oc-app_store-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-app_store",
      toString: function () {
        return this.url;
      }
    }